var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      staticClass: "text--primary",
      class:
        _vm.contentClass +
        " " +
        _vm.textColor +
        (_vm.icon && _vm.showIcon
          ? " pl-1 pr-2 "
          : _vm.showIcon
          ? ""
          : _vm.close
          ? "pl-2 pr-1"
          : " px-3 "),
      style: _vm.icon
        ? {}
        : { borderLeft: !_vm.icon ? "8px solid " + _vm.slideColor : "none" },
      attrs: {
        small: _vm.small,
        pill: _vm.icon,
        label: !_vm.icon,
        close: _vm.close,
        color: _vm.bgColor,
      },
      on: {
        "click:close": function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _vm.icon && _vm.showIcon
        ? _c("svg-icon", {
            staticClass: "mr-1",
            attrs: {
              size: "18",
              fill: _vm.slideColor ? _vm.slideColor : "grey",
              iconClass: "LabeledColour",
            },
          })
        : _vm._e(),
      _vm._t("status"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }